<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <b-modal
                ref="modalError"
                size="md"
                title="Disclaimer"
                hide-footer
                hide-header-close
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
        >
            <div class="modal-body-disclaimer">
                <p class="paragraph">
                    Hi
                    <span style="text-transform: capitalize">{{
                        user.firstName
                    }}</span
                    >! <br /><br />
                    <!--It looks like you've hit the limit on the number of profiles-->
                    <!--included in your current pricing plan :( To continue to-->
                    <!--onboard another profile, you will have to purchase the next-->
                    <!--package. Would you like to upgrade now?-->
                    To begin onboarding and verifying profiles with your Idenfo
                    Direct account, please subscribe to one of our flexible
                    pricing packages.
                </p>
                <div class="row justify-content-center">
                    <div class="m-2">
                        <b-button variant="primary" @click="payments"
                        >Yes! Take me to Payments</b-button
                        >
                    </div>
                    <div class="m-2">
                        <b-button variant="secondary" @click="currentPlan"
                        >No! I am sticking to my current plan
                        </b-button>
                    </div>
                </div>
            </div>
        </b-modal>
        <div class="row">
            <div class="col-lg-12">
                <h3>Step 1: Upload Documents</h3>
            </div>
            <div class="col-lg-8">
                <div class="row form-options">

                    <div class="col-lg-6">
                        <cropper 
                                ref="cropper" 
                               :formData="formData2" 
                               :field="{
                                        isRequired: true,
                                        isLocked: true,
                                        key: 'documentInfo.identity.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identity.originalFileName',
                                        label: labelForCompanyId(),
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes
                                    }">
                        </cropper>
                    </div>
                    <div
                            v-if="this.$store.getters.form.type=='company'"
                            class="col-lg-12 row"
                    >
                        <div :class="fieldEmiratesID.show ? 'col-lg-6' : ''">
                            <div v-if="fieldEmiratesID.show">
                                <emirates-id
                                        :profile-type="profileType"
                                ></emirates-id>
                            </div>
                        </div>
                        <div
                                :class="fieldEmiratesIDBack.show ? 'col-lg-6' : ''"
                        >
                            <div v-if="fieldEmiratesIDBack.show">
                                <emirates-id-back
                                        v-validate="{
                                        required: false,
                                    }"
                                        :profile-type="profileType"
                                ></emirates-id-back>
                            </div>
                        </div>
                        <div :class="fieldVisaPage.show ? 'col-lg-6' : ''">
                            <div v-if="fieldVisaPage.show">
                                <visa-page
                                        :profile-type="profileType"
                                ></visa-page>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div>
                                <address-proof></address-proof>
                            </div>
                        </div>

                        <div
                                v-if="$store.state.registration.form.identityInfo.type"
                                class="col-lg-12"
                        >
                            <b-form-group
                                    label="Please upload all relevant documents"
                                    label-for="contact-email-input"
                            >
                                <div>
                                    <vue-dropzone
                                            id="dropzone"
                                            ref="myVueDropzone"
                                            :options="dropzoneOptions"
                                            @vdropzone-complete="afterComplete"
                                            @vdropzone-removed-file="onFileRemove"
                                            @vdropzone-error="onError"
                                            @vdropzone-mounted="prePopulate"
                                    ></vue-dropzone>
                                </div>
                                <small class="mt-2"
                                ><em class="dropzoneText"
                                >Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                    MAX)</em
                                ></small
                                >
                            </b-form-group>
                        </div>
                    </div>
                    <!--if country is UAE-->
                </div>
                <div class="row mt-2">
                    <div class="col-lg-6">
                        <base-button
                                btn-type="submit"
                                btn-variant="primary"
                                btn-label="CONTINUE"
                                :class="loading ? 'disabled' : ''"
                                :disabled="loading"
                        ></base-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mb-4 mb-md-0 form-options">
                <b-form-group
                        label="SAMPLE DOCUMENT"
                        label-for="sampleId"
                >
                    <img
                            style="max-width: 270px"
                            v-authenticated-image="cardImageUrl"
                    />

                </b-form-group>
            </div>
        </div>
    </b-form>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import request from '@/utils/request'
    import _ from 'lodash'

    import IdentityType from '@/components/registration/IdentityType.vue'
    import CardType from '@/components/registration/CardType.vue'
    import UtilityBill from '@/components/registration/UtilityBill.vue'
    import VisaPage from '@/components/registration/VisaPage.vue'
    import EmiratesId from '@/components/registration/EmiratesId.vue'
    import EmiratesIdBack from '@/components/registration/EmiratesIdBack.vue'
    import AddressProof from '@/components/registration/AddressProof.vue'
    import Cropper from '@/components/registration/Cropper.vue'
    import IdBackCropper from '@/components/registration/IdBackCropper.vue'
    import AdditionalDocument from '@/components/registration/AdditionalDocument.vue'
    import proofOfEmployment from '@/components/registration/ProofOfEmployment.vue'
    import EducationalDocument from '@/components/registration/EducationalDocument.vue'
    // import ConsentForm from '@/components/registration/ConsentForm.vue'
    import LicenseFrontCropper from '@/components/registration/LicenseFrontCropper.vue'
    import LicenseBackCropper from '@/components/registration/LicenseBackCropper.vue'

    import resource from '@/api/resource'

    const dataSegmentApi = new resource('users/data-segment')
    const viewBrandingApi = new resource('configurations/branding')
    const modulesApi = new resource('configurations/modules')
    import vue2Dropzone from 'vue2-dropzone'

    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        /*
          |--------------------------------------------------------------------------
          | Component > components
          |--------------------------------------------------------------------------
          */
        components: {
            IdentityType,
            CardType,
            Cropper,
            // ConsentForm,
            //IdentityDocument,
            UtilityBill,
            VisaPage,
            EmiratesId,
            AddressProof,
            EmiratesIdBack,
            IdBackCropper,
            LicenseFrontCropper,
            LicenseBackCropper,
            AdditionalDocument,
            proofOfEmployment,
            EducationalDocument,
            vueDropzone: vue2Dropzone,
        }, // End of Component > components

        /*
          |--------------------------------------------------------------------------
          | Component > props
          |--------------------------------------------------------------------------
          */
        props: {}, // End of Component > props

        /*
          |--------------------------------------------------------------------------
          | Component > data
          |--------------------------------------------------------------------------
          */
        data() {
            return {
                placeHolderField :'Select scan copy (JPG, PNG, PDF or JPEG file)',
                fileTypes:"image/*,application/pdf",
                dataFetch: false,
                soundeffect: new Audio(),
                country: process.env.VUE_APP_COUNTRY,
                tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
                liveness: null,
                counter: null,
                subscription: null,
                redirection: true,
                validateFront: true,
                validateBack: true,
                tier: null,
                nameScreening: null,
                deepLinkRegisteredCount: 0,
                query: {
                    startAt: 1,
                    keyword: '',
                    perPage: 10,
                    status: null,
                    sortBy: 'idenfoId',
                    sortOrder: 'desc',
                },
                riskFactor: null,
                path: 'users/temp-applications',

                resourceApi: null,
                cardImageUrl : '',
                associateData: [],
                formData2: {
                    dataSegmentId: null,
                    riskFactor: null,
                    liveness: null,
                    nameScreening: null,
                    documentUpload: null,
                    documentValidation: null,
                    companyType: null,
                },
                fieldVisaPage: {
                    show: true,
                },
                fieldEmiratesID: {
                    show: true,
                },
                fieldAddressProof: {
                    show: true,
                },
                fieldEmiratesIDBack: {
                    show: true,
                },
                profileType: '',
                backScanCopyHidden: false,
                dropzoneOptions: {
                    url: process.env.VUE_APP_FILE_SERVICE_URL,
                    autoProcessQueue: true,
                    // acceptedFiles: "image/jpeg,image/png,image/gif",
                    acceptedFiles:
                        'application/pdf,.doc,.docx , image/png, .jpg,.jpeg',
                    uploadMultiple: false,
                    maxFiles: 10,
                    maxFilesize: 5,
                    addRemoveLinks: true,
                    dictDefaultMessage: 'Drop file here or Select file',
                    init: function () {
                        this.on('sending', function (file, xhr, formData) {
                            formData.append('type', 'otherDocuments')
                        })
                    },
                },
            }
        }, // End of Component > data

        created() {
            this.resourceApi = new resource(this.path)

            // if (this.field.key == 'pepDeclaration.other') {
            // console.log(this.$store.state.registration.form.pepInfo)
            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                this.$store.watch(
                    (state) => {
                        return this.$store.state.registration.form.identityInfo.type
                    },
                    (newValue, oldValue) => {
                        // console.log("new Value",newValue)
                        if (newValue == 'passport') {
                            this.backScanCopyHidden = true
                        } else {
                            this.backScanCopyHidden = false
                        }
                    }
                )
            }
            // }
        },

        /*
          |--------------------------------------------------------------------------
          | Component > computed
          |--------------------------------------------------------------------------
          */
        computed: {
            ...mapState({
                userOcr: (state) => state.registration.useOcr,
            }),

            ...mapGetters(['dataSegmentId', 'loading', 'form', 'user','dataSegmentConfigurations']),

            dataSegmentId() {
                if (this.$route.params.dataSegmentId) {
                    return this.$route.params.dataSegmentId
                }
                return this.$store.getters.dataSegmentId
            },
            instance() {
                if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.type',
                        value: 'id',
                    })
                    return 'Pakistan'
                } else {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.type',
                        value: 'passport',
                    })
                    return process.env.VUE_APP_COUNTRY
                }

            },
        }, // End of Component > computed

        /*
          |--------------------------------------------------------------------------
          | Component > watch
          |--------------------------------------------------------------------------
          */

        watch: {
            /**
             * Handle when the file is uploaded successfully
             *
             * @return {void}
             */
            dataSegmentId(value) {
                if (value) {
                    this.getModuleData()
                }
            },
        }, // End of Component > methods

        /*
          |--------------------------------------------------------------------------
          | Component > mounted
          |--------------------------------------------------------------------------
          */
        async mounted() {
            this.getBrandingData()
            if (!this.dataSegmentId) {
                this.$router.push({ name: 'login-page' })
            }
            await this.getModuleData()
            if (this.formData2) {
                if (this.formData2.documentUpload == false) {
                    this.$router.push({ name: 'self-registration-company-setup-profile' })
                }
            }

        }, // End of Component > watch

        /*
          |--------------------------------------------------------------------------
          | Component > methods
          |--------------------------------------------------------------------------
          */
        methods: {
            /**
             * Handle when the form has been submitted
             *
             * @return {void}
             */
            labelForCompanyId(){
               if(['UK'].includes(this.tempCountry)){
                 return "Certificate of incorporation"
               }
               else{
                 return "Trade License / Registration Certificate"
               }
            },
            // async consentFormDownload(){

            //    await axios({
            //                 method: 'get',
            //                 url: `${process.env.VUE_APP_API_URL}files/logo/consentForm.pdf`,
            //                 responseType: 'blob',
            //             }).then((response) => {
            //                 const url = window.URL.createObjectURL(new Blob([response.data]))
            //     const link = document.createElement('a')
            //     link.href = url
            //     link.setAttribute(
            //         'download',
            //         `consentForm.pdf`
            //     )
            //     document.body.appendChild(link)
            //     link.click()

            //             })


            // },
            async prePopulate(){
                if(!this.$store.state.registration.form.documentInfo.otherDocuments){
                    let docs = this.customerDetails.documentInfo.otherDocuments
                    console.log("logs from prepopulate",docs)
                    let size
                    for(var i=0; i<docs.length;i++){

                        let url = `${process.env.VUE_APP_FILE_SERVICE_URL}customer-documents/${docs[i].fileName}`
                        await fetch(url, {
                            method: 'HEAD'
                        })
                            .then(response => response.headers.get('Content-Length'))
                            .then(s => size=s);
                        var file = { size:size, name: docs[i].originalFileName,...docs[i] };
                        await this.$refs.myVueDropzone.manuallyAddFile(file, url);
                    }
                    this.$store.commit('updateField', {
                        key: 'documentInfo.otherDocuments',
                        value: docs,
                    })
                }else{
                    let docs = this.$store.state.registration.form.documentInfo.otherDocuments
                    console.log("logs from prepopulate",docs)
                    let size
                    for(var i=0; i<docs.length;i++){

                        let url = `${process.env.VUE_APP_FILE_SERVICE_URL}customer-documents/${docs[i].fileName}`
                        await fetch(url, {
                            method: 'HEAD'
                        })
                            .then(response => response.headers.get('Content-Length'))
                            .then(s => size=s);
                        var file = { size:size, name: docs[i].originalFileName,...docs[i] };
                        await this.$refs.myVueDropzone.manuallyAddFile(file, url);
                    }
                    this.$store.commit('updateField', {
                        key: 'documentInfo.otherDocuments',
                        value: docs,
                    })
                }
// })


            },

            onError(file, message, xhr) {
                // console.log('on upload error',file,message,xhr)
                this.$refs.myVueDropzone.removeFile(file)
                this.$store.commit('setError', message)
            },
            onFileRemove(file) {
                if (this.$route.name == 'self-registration-company-upload-document') {
                    let arr = []
                    if (
                        this.$store.state.registration.form.documentInfo
                            .otherDocuments !== undefined
                    ) {
                        if (
                            this.$store.state.registration.form.documentInfo
                                .otherDocuments.length > 1
                        ) {
                            this.$store.state.registration.form.documentInfo.otherDocuments.forEach(
                                (value, index) => {
                                    if (value.uploadID == file.uploadID) {
                                    } else {
                                        let fileObj = {
                                            fileName: value.fileName,
                                            originalFileName:
                                            value.originalFileName,
                                            uploadID: value.uploadID,
                                        }
                                        arr.push(fileObj)
                                        this.updateOriginalFileName(arr)
                                    }
                                }
                            )
                        } else {
                            this.updateOriginalFileName(arr)
                        }
                    }
                }
            },
            afterComplete(file) {
                let response = JSON.parse(file.xhr.response)
                console.log(response.data.fileName)
                let fileObj = {
                    fileName: response.data.fileName,
                    originalFileName: file.name,
                    uploadID: file.upload.uuid,
                }
                let arr = []
                if (
                    this.$store.state.registration.form.documentInfo
                        .otherDocuments !== undefined
                ) {
                    arr =
                        this.$store.state.registration.form.documentInfo
                            .otherDocuments
                }
                arr.push(fileObj)
                this.updateOriginalFileName(arr)
            },
            updateOriginalFileName(newValue) {
                this.$store.commit('updateField', {
                    key: 'documentInfo.otherDocuments',
                    value: newValue,
                })
            },
            payments() {
                this.$refs.modalError.hide()
                this.$router.push('/billing')
            },
            currentPlan() {
                this.$refs.modalError.hide()
                this.$router.push('/customer-profiles')
            },

            async onSubmit() {
                // validate the form fields
                if (this.validateBack && this.validateFront) {
                    const result = await this.$validator.validateAll()

                    // Check if validation fails
                    if (result) {
                        // this.$store.commit('setLoading', true)
                        // console.log('public registration')
                        // console.log(this.$route.meta.publicRegistration)

                        this.soundon()
                        this.nextModule('on-submit')
                    } else {
                        this.$store.commit('setError', this.errors.all()[0])
                    }
                } else {
                    this.$store.commit(
                        'setError',
                        'Your uploaded document has not been verified by our system, please try again.'
                    )
                }
            }, // End of onSubmit() method
            soundon() {
                const sound =
                    'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
                this.soundeffect.src = sound
                this.$store.commit('updateField', {
                    key: 'soundSrc',
                    value: this.soundeffect,
                })
            },

            async getBrandingData() {
                let { data } = await viewBrandingApi.list()
                this.$store.commit('setDisplaySetting', data.data)
                if(data.data.bgImages)
                {
                    this.cardImageUrl =  'logo/'+data.data.bgImages.companyLicense.fileName
                }
            },

            async getModuleData() {
                try {
                    if (this.dataSegmentId) {
                        // let { data } = await modulesApi.list({
                        //     dataSegmentId: this.dataSegmentId,
                        // })
                      if (!_.isEmpty(this.dataSegmentConfigurations)) {
                            this.formData2 = this.dataSegmentConfigurations
                        }
                        this.showPageLoader = false
                    }
                } catch (error) {
                    this.showPageLoader = false
                }
            },
            setMultipleUploadDocuments(profileType) {
                //   console.log('Setting Data for UAE for profile type : ', profileType)

                if (profileType == 'Citizen') {
                    this.fieldVisaPage.show = false
                    // this.fieldVisaPage.isRequired = false
                } else if (profileType == 'Non-resident (tourist)') {
                    this.fieldVisaPage.show = false
                    // this.fieldVisaPage.isRequired = false
                    this.fieldEmiratesID.show = false
                    this.fieldEmiratesIDBack.show = false
                    // this.fieldEmiratesID.isRequired = false
                } else {
                }
            },

            async nextModule(type='')
            {
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'self-registration-company-setup-profile',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                            token: this.$route.params.token,
                        },
                    })
                }
                else {
                    if(this.formData2.nameScreening==false)
                    {
                        if(this.formData2.riskFactor == false)
                        {
                            this.$router.push({name: 'self-registration-company-preview'})
                        }
                        else {
                            this.$router.push({name: 'self-registration-company-account-info'})
                        }
                    }
                    else
                    {
                        if(type=='on-submit')
                        {
                            this.$router.push({
                                name: 'self-registration-company-setup-profile',
                                params: {
                                    dataSegmentId: this.dataSegmentId,
                                    token: this.$route.params.token,
                                },
                            })
                        }
                        else
                        {
                            this.$router.push({name: 'self-registration-company-setup-profile'})
                        }

                    }

                }
            }
        }, // End of Component > mounted
    } // End of export default
</script>
